import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../components/loading";
import GoBackBtn from "../components/goBackBtn";
import FinishModal from "../components/redeemPage/finishModal";
import ErrorModal from "../components/errorModal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { IconButton, Input, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import styles from "../styles/UserSetting.module.scss";
import _ from "lodash";
import store from "store-js";
import API from "../services/api";
import { useTranslation } from "react-i18next";
import { useCookieState } from 'ahooks';

export default function UserSetting({ config }) {
  const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
  const pageSetting = config.userSettingPage_setting;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currPwd, setCurrPwd] = useState(null);
  const [newPwd, setNewPwd] = useState(null);
  const [confirmPwd, setConfirmPwd] = useState(null);
  const [showCurrPwd, setShowCurrPwd] = useState(null);
  const [showNewPwd, setShowNewPwd] = useState(null);
  const [showConfirmPwd, setShowConfirmPwd] = useState(null);
  const [showErr, setShowErr] = useState(false);
  const [errType, setErrType] = useState(null);
  const [disableBtn, setDisableBtn] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errModalMsg, setErrModalMsg] = useState(null);
  const [consoleMsg, setConsoleMsg] = useState(null);
  const [transition, setTransition] = useState(false);

  useEffect(() => {
    if (currPwd && newPwd && confirmPwd) setDisableBtn(false);
  }, [currPwd, newPwd, confirmPwd]);

  // useEffect(() => {
  //   if (showSuccess)
  //     setTimeout(() => {
  //       reLogin();
  //     }, 300);
  // }, [showSuccess]);

  const handleShowPwd = (name) => {
    name === "oldpwd"
      ? setShowCurrPwd(!showCurrPwd)
      : name === "newpwd"
      ? setShowNewPwd(!showNewPwd)
      : setShowConfirmPwd(!showConfirmPwd);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFieldsChange = (e) => {
    let field = e.currentTarget.name;
    let val = e.currentTarget.value;

    if (field === "oldpwd") {
      setCurrPwd(val);
    } else if (field === "newpwd") {
      // Check if input contains both Num & Alphabets
      let numeric_alpha = /^(?=.*[a-zA-Z])(?=.*[0-9])/;
      if (val.match(numeric_alpha) && val.length >= 8) {
        setNewPwd(val);
        setShowErr(false);
      } else {
        setErrType("notMatchRequirement");
        setShowErr(true);
      }
    } else if (field === "confirmNewpwd") {
      setConfirmPwd(val);
    }
  };

  const reLogin = () => {

    const api = new API(token);
    api
      .userLogout()
      .then((res) => {
        return;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        store.clearAll();
        navigate("/");
      });
  };

  const handleConfirmUpdate = () => {
    if (currPwd !== newPwd && newPwd === confirmPwd) {
      const api = new API(token);

      api
        .changePassword(currPwd, newPwd)
        .then((res) => {
          if (res && res.response.code === "200") {
            setTransition(true);
            setShowSuccess(true);
          } else if (res.response.code === "400") {
            setErrModalMsg(t("userSettingPage_wrongPwd_errMsg"));
          } else {
            res.error === "invalidToken"
              ? setErrModalMsg(t("errMsg_loginErr"))
              : setErrModalMsg(t("userSettingPage_wrongPwd_errMsg"));
          }
        })
        .catch((err) => {
          console.log(err);
          setErrModalMsg("netowrkErr");
        })
        .finally(() => setShowErr(false));
    } else {
      currPwd === newPwd
        ? setErrType("oldNewPwdSame")
        : setErrType("newPwdsMismatch");
      setShowErr(true);
    }
  };

  return (
    <div className="marginContent">
      <div className="content noselect">
        <div className="backBtnDiv" style={{ width: "fit-content" }}>
          <GoBackBtn color={config.theme.color} />
        </div>
        {/* <div className={styles.editBtnDiv}>
          {pageSetting.confirmUpdateBtn && (
            <button
              type="button"
              className="textBtn"
              disabled={disableBtn}
              style={{
                marginTop: "4px",
                color: disableBtn ? "#cccccc" : config.theme.color,
              }}
              onClick={handleConfirmUpdate}
            >
              {t(`${pageSetting.confirmUpdateBtn.label}`)}
            </button>
          )}
        </div> */}
        <div style={{ marginTop: "50px" }}>
          <h2 className={styles.title}>{t(`${pageSetting.title}`)}</h2>
        </div>

        {pageSetting.editFields?.map((field, i) => (
          <List key={i}>
            <p className={styles.customMargin}>{t(`${field.label}`)}</p>
            <ListItem style={{ paddingLeft: "0", paddingRight: "0" }}>
              <Input
                name={field.name}
                placeholder={t(`userSettingPage_${field.name}_placeholder`)}
                type={
                  (field.name == "oldpwd" && showCurrPwd) ||
                  (field.name == "newpwd" && showNewPwd) ||
                  (field.name == "confirmNewpwd" && showConfirmPwd)
                    ? "text"
                    : field.type
                }
                style={{ width: "100%" }}
                onChange={(e) => handleFieldsChange(e)}
                endAdornment={
                  <InputAdornment position="end" variant="outlined">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleShowPwd(field.name)}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {(field.name == "oldpwd" && showCurrPwd) ||
                      (field.name == "newpwd" && showNewPwd) ||
                      (field.name == "confirmNewpwd" && showConfirmPwd) ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </ListItem>
          </List>
        ))}

        <div style={{ display: "flex", alignItems: "baseline" }}>
          <p
            style={{
              fontSize: "14px",
              marginTop: "5px",
              color: "#999999",
            }}
          >
            {t("home_pwd_hints")}
          </p>
        </div>

        {showErr && errType
          ? _.get(pageSetting.errMsgs, errType).map((msg, i) => (
              <div key={i}>
                <p className={styles.errMsg}>{t(`${msg}`)}</p>
                <br />
              </div>
            ))
          : null}

        {pageSetting.confirmUpdateBtn && (
          <div className={styles.btnWrapper}>
            <button
              className={
                pageSetting.confirmUpdateBtn.style === "color"
                  ? "colorBtn"
                  : "whiteBtn"
              }
              type="button"
              disabled={disableBtn}
              style={{
                color: pageSetting.confirmUpdateBtn.txt_color,
                backgroundColor: disableBtn ? "#cccccc" : config.theme.color,
                border: "none",
              }}
              onClick={handleConfirmUpdate}
            >
              {t(`${pageSetting.confirmUpdateBtn.label}`)}
            </button>
          </div>
        )}
      </div>

      <FinishModal
        openModal={showSuccess}
        from="userSetting"
        msg={t(`${pageSetting.successMsg}`)}
        config={config}
        t={t}
        handleCloseModal={reLogin}
      />

      <ErrorModal
        openModal={errModalMsg || consoleMsg ? true : false}
        errorMsg={errModalMsg}
        consoleMsg={consoleMsg}
        handleCloseModal={() => {
          setErrModalMsg(null);
        }}
        config={config}
      />
      {transition && <Loading />}
    </div>
  );
}
